import { VesselStatusEnum } from './enums';

export class DashboardTrialStatus {
    public status: VesselStatusEnum;
    public message: string;
    
}